export default __webpack_public_path__ + "static/media/WumboLogoAnimation.6830218b.gif";